import * as THREE from 'three';
import p5 from "p5";
import { QTreeRect } from './QTreeRect';
import { Params } from '../../data/Params';
import { Utils } from '../../data/Utils';
import { Random } from '../../data/Random';


export class KTree {

    _p5         :p5;
    _width      :number = 512;
    _height     :number = 512;

    _gridWidth  :number = 6;
    _gridHeight  :number = 6;
    

    _maxDepth   :number = 0;
    public rects       :QTreeRect[];

    
    constructor(){

    }

    update(depth:number){

        this.rects = [];
        
        this._gridWidth=this._gridHeight=16;

        this.split(0,0,this._gridWidth,this._gridHeight,0);

        Utils.swapRandomly(this.rects,0.2);
    }

    hide(){
        for(let i=0;i<this.rects.length;i++){
            this.rects[i].hide();
        }
    }

    split(
        xx:number,yy:number,ww:number,hh:number,depth:number
    ){

        if(
            (ww<=1 && hh<=1) || (Random.value<0.1*depth && depth>=3)
        ){

            let qtree= new QTreeRect(
                xx/this._gridWidth  * this._width,
                yy/this._gridHeight * this._height,
                ww/this._gridWidth  * this._width,
                hh/this._gridHeight * this._height,
                depth
            );
            
            qtree.setRule(
                Params.rules[Math.floor(Random.value*Params.rules.length)]
            );

            this.rects.push(qtree);
            return;
        }


        //縦に分割するか、横に分割するか
        let isH = Random.value<0.5 ? true : false;
        
        if(ww<=1) isH=false;//
        else if(hh<=1) isH=true;



        let rand1 = (Random.value+Random.value)/2;
        let rand2 = (Random.value+Random.value)/2;

        let nx = 1+Math.floor((ww-2) * rand1);
        let ny = 1+Math.floor((hh-2) * rand2);
        
        let w1 = nx;
        let h1 = ny;

        let w2 = ww - w1;
        let h2 = hh - h1;

        let next = depth+1;

        if(isH){
            //console.log("横A",xx,yy,w1,hh,next );
            //console.log("横B",xx+w1,yy,w2,hh,next );
            //横に２個＝縦に切る
            this.split(xx,yy,w1,hh,next);//
            this.split(xx+w1,yy,w2,hh,next);//
        }else{
            //console.log("縦A",xx,yy,ww,h1,next );
            //console.log("縦B",xx,yy+h1,ww,h2,next );
            //縦に２個＝横に切る
            this.split(xx,yy,ww,h1,next);//
            this.split(xx,yy+h1,ww,h2,next);//
        }
        
    }


}